<template>
  <div id="portfolioCard">
    <a :href="`${startup.ref}`" target="blank">
      <div
        class="card"
        @mouseover="isActive = true"
        @mouseleave="isActive = false"
      >
        <img
          :src="require(`../assets/startup/${startup.img}`)"
          class="card-image"
        />
        <img
          v-show="!isActive && startup.exited"
          src="../assets/exited.png"
          class="exited"
        />
        <transition name="custom-classes-transition">
          <div
            v-if="isActive"
            class="hoverText"
            style="display:flex;align-items:flex-start;"
          >
            <div
              style="display:flex;height:auto;align-items:center;justify-content:space-between;width:100%;padding-left:10px"
            >
              <div>
                <i class="fas fa-map-marker-alt"></i>
                {{ startup.localisation }}
              </div>
              <span class="startupType">
                {{ startup.type }}
              </span>
            </div>
          </div>
        </transition>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: "PortfolioCard",
  props: ["startup"],
  data() {
    return {
      isActive: false
    };
  }
};
</script>

<style>
#portfolioCard .hoverText {
  position: absolute;
  height: 100%;
  width: 100%;
  padding: 0px;
  padding-bottom: 0;
  display: grid;
  justify-content: center;
  color: #fa2d3c;
}

#portfolio .exited {
  position: absolute;
  max-width: 100%;
  height: auto;
  max-height: 100%;
}

#portfolioCard .startupType {
  background-color: #fa2d3c;
  color: white;
  width: 140px;
  height: auto;
  padding: 5px;
  font-size: 0.9rem;
}

#portfolioCard .fas {
  color: red;
}

#portfolioCard .card {
  width: 300px;
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: transform 0.1s ease;
}

#portfolioCard .card-image {
  max-width: 70%;
  height: auto;
  max-height: 70%;
}

#portfolioCard .card:hover {
  box-shadow: 20px 20px 40px 0px rgba(0, 0, 0, 0.5);
}
</style>
